export const CASE_TYPE_REPORT_FETCHING = 'CASE_TYPE_REPORT_FETCHING';
export const CASE_TYPE_REPORT_FETCH_ERROR = 'CASE_TYPE_REPORT_FETCH_ERROR';
export const CASE_TYPE_REPORT_GET_GRADES = 'CASE_TYPE_REPORT_GET_GRADES';
export const CASE_TYPE_REPORT_GET_REPORT = 'CASE_TYPE_REPORT_GET_REPORT';
export const CASE_TYPE_REPORT_GET_CASE_TYPES =
  'CASE_TYPE_REPORT_GET_CASE_TYPES';



// WEBPACK FOOTER //
// ./src/pages/casetype/state/casetypereport/types.js